import request from '@/utils/axios'

/************  要素接口  ************/

// 获取地图视频列表
export function GetMapVIdeoList(params) {
  return request({
    url: 'api/MapVIdeo/GetMapVIdeoList',
    method: 'post',
    data: params
  })
}

// 创建地图视频文件夹
export function createFile(params) {
  return request({
    url: 'api/MapVIdeo/CreateMapVIdeoDir',
    method: 'post',
    data: params
  })
}

// 创建地图视频
export function createMapVIdeo(params) {
  return request({
    url: 'api/MapVIdeo/CreateMapVIdeo',
    method: 'post',
    data: params
  })
}

// 删除我的视频 
export function deleteMapVIdeo(params) {
  return request({
    url: "api/MapVIdeo/DeleteMapVIdeo",
    method: "post",
    data: params
  });
}

//移动地图视频 
export function moveMapVIdeo(params) {
  return request({
    url: "api/MapVIdeo/moveMapVIdeo",
    method: "post",
    data: params
  });
}

// 获取我的视频 -> 树状列表
export function GetVideoDocTree(params) {
  return request({
    url: "api/MapVIdeo/GetTreeMapVIdeo",
    method: "get",
    params: params
  });
}

export function GetMapVIdeoDetails(params) {
  return request({
    url: "api/MapVIdeo/GetMapVIdeoDetails",
    method: "get",
    params: params
  });
}
///api/MapVIdeo/UpdateVIdeoContents
export function UpdateVIdeoContents(params) {
  return request({
    url: "api/MapVIdeo/UpdateVIdeoContents",
    method: "post",
    data: params
  });
}

// 生成视频
export function DownMapVIdeo(params) {
  return request({
    url: "api/MapVIdeo/DownMapVIdeo",
    method: "post",
    data: params
  });
}

// 获取地图视频分享文件列表
export function getMapVideoShareList(params) {
  return request({
    url: `api/MapVIdeo/getMapVideoShareList`,
    method: "post",
    data: params
  });
}

// 查询地图视频协助者列表
export function getMapVideoSharedUsers(params) {
  return request({
    url: `api/MapVIdeo/getMapVideoSharedUsers`,
    method: "post",
    data: params
  });
}

// 添加地图视频协助者
export function addMapVideoSharedUsers(params) {
  return request({
    url: `api/MapVIdeo/addMapVideoSharedUsers`,
    method: "post",
    data: params
  });
}

// 获取地图视频分享链接信息
export function getMapVideoShareCre(params) {
  return request({
    url: `api/MapVIdeo/getMapVideoShareCre`,
    method: "post",
    data: params
  });
}

// 生成地图视频分享链接信息
export function createMapVIdeoShareCre(params) {
  return request({
    url: `api/MapVIdeo/createMapVIdeoShareCre`,
    method: "post",
    data: params
  });
}

// 获取分享文件列表
export function shareMapVideo(params) {
  return request({
    url: `/api/MapVIdeo/ShareMapVideo`,
    method: "get",
    params: params
  });
}

// 重命名视频
export function RnameMapVIdeo(params) {
  return request({
    url: `api/MapVIdeo/RnameMapVIdeo`,
    method: "post",
    data: params
  });
}

// 拷贝视频
export function CopyMapVIdeo(params) {
  return request({
    url: `api/MapVIdeo/CopyMapVIdeo`,
    method: "post",
    data: params
  });
}

// 获取字幕数据
export function GetNewSubtitle(params) {
  return request({
    url: `api/MapVIdeo/GetNewSubtitle`,
    method: "get",
    params: params
  });
}

// 更新字幕
export function UpdateVIdeoSubtitle(params) {
  return request({
    url: `api/MapVIdeo/UpdateVIdeoSubtitle`,
    method: "post",
    data: params
  });
}

// 获取视频符号数据
export function GetNewSymbol(params) {
  return request({
    url: `api/MapVIdeo/GetNewSymbol`,
    method: "get",
    params: params
  });
}

// 更新符号
export function UpdateVIdeoSymbol(params) {
  return request({
    url: `api/MapVIdeo/UpdateVIdeoSymbol`,
    method: "post",
    data: params
  });
}